import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {BasePalette} from '#core/application/modules/base-palette.js';
import {generateInfoNotification} from '#core/application/modules/tiles/notification/index.js';
import {generateEarlyPayoutIndicator} from '#core/application/modules/tiles/bonus-indicator/index.js';

import BET_BUILDER_SELECTION_ITEM from './bet-builder-selection-item.palette-schema.yaml';

registerTileSchema(BET_BUILDER_SELECTION_ITEM);

export function generateBetBuilderSelectionItem(TILE) {
    return {
        selectionLabel: {
            style: {
                ...TILE.BB_BET_SELECTION_NAME_TEXT,
            },
        },
        labelsInnerContainer: {
            useSpacingSeparator: true,
            itemSpacing: 4,
        },
        marketInfoContainer: {
            style: {
                minWidth: 0,
            },
        },
        marketName: {
            ...TILE.BB_BET_MARKET_TEXT,
        },
        eventName: {
            style: TILE.BB_BET_EVENT_NAME_TEXT,
        },
        separatorLineBase: {
            style: {
                backgroundColor: TILE.BB_BET_PATH_LINE_COLOR,
                opacity: '0.16',
            },
        },
        separatorLineTop: {
            style: {
                // 6px is default value from mojito
                flexBasis: Math.max(0, 6 + BasePalette.palette.VERTICAL_ALIGN_FIX),
            },
        },
        selectionIcon: {
            src: 'circle',
            style: {
                fill: TILE.BB_BET_ICON_COLOR,
            },
        },
        suspendedSelectionLabel: {
            suspendedText: {
                container: {
                    ...resolveBackground(TILE.BB_BET_SUSPENDED_NOTIFICATION.INFO_BG),
                },
                style: {
                    ...TILE.BB_BET_SUSPENDED_NOTIFICATION_TEXT,
                },
            },
        },
        earlyPayoutIndicator: generateEarlyPayoutIndicator(TILE.BB_EARLY_PAYOUT_INDICATOR),
        voidReasonMessage: {
            container: {
                style: {
                    padding: '0 0 4px',
                },
            },
            notification: generateInfoNotification(TILE.BB_BET_VOID_REASON_NOTIFICATION),
        },
        removePartSelection: {
            removeButton: {
                imageButton: {
                    buttonIcon: icon(TILE.BB_REMOVE_PART_BUTTON.CLOSE_BUTTON_ICON_COLOR, 'cross'),
                    innerContainer: {
                        style: {
                            padding: Math.max(0, 4 + BasePalette.palette.VERTICAL_ALIGN_FIX),
                        },
                    },
                },
            },
        },
    };
}
